import { TranslationObject } from '../../i18n/translation';

const translations: TranslationObject = {
  defaultContents: {
    id: 'confirmationDialog.defaultContents',
    nb: 'Er du sikker?',
    en: 'Are you sure?',
  },
  cancel: { id: 'confirmationDialog.cancel', nb: 'Avbryt', en: 'Cancel' },
  ok: { id: 'confirmationDialog.ok', nb: 'Ok', en: 'Ok' },
};

export default translations;
